export default "__VITE_ASSET__DkpOKc2K__"